import React from 'react';

import AcIcon from '../Icons/AcIcon';
import AcOnIcon from '../Icons/AcOnIcon';
import AirConditionerIcon from '../Icons/AirConditionerIcon';
import ArrowDownIcon from '../Icons/ArrowDownIcon';
import ArrowRight from '../Icons/ArrowRight';
import ArrowLeft from '../Icons/ArrowLeft';
import ArrowUpIcon from '../Icons/ArrowUpIcon';
import BathroomIcon from '../Icons/BathroomIcon';
import BlanketIcon from '../Icons/BlanketIcon';
import BushostnessIcon from '../Icons/BushostnessIcon';
import BusIcon from '../Icons/BusIcon';
import CallSupportIcon from '../Icons/CallSupportIcon';
import CentralTvIcon from '../Icons/CentralTvIcon';
import ChargingpointIcon from '../Icons/ChargingpointIcon';
import CupholderIcon from '../Icons/CupholderIcon';
import DefaultAmenitiesICon from '../Icons/DefaultAmenitiesIcon';
import DropArrowIcon from '../Icons/DropArrowIcon';
import EmergencyContactIcon from '../Icons/EmergencyContactIcon';
import EmergencyExitIcon from '../Icons/EmergencyexitIcon';
import EticketIcon from '../Icons/Eticketicon';
import FacialTissueIcon from '../Icons/FacialTissueIcon';
import FireExtinguisherIcon from '../Icons/FireExtinguisherIcon';
import FoodIcon from '../Icons/FoodIcon';
import FreshnerIcon from '../Icons/FreshnerIcon';
import HammerIcon from '../Icons/HammerIcon';
import HeadsetIcon from '../Icons/HeadsetIcon';
import HeaterIcon from '../Icons/HeaterIcon';
import LiveBusIcon from '../Icons/LiveBusIcon';
import LiveBusTracking from '../Icons/LiveBusTracking';
import MassageChairIcon from '../Icons/MassagechairIcon';
import MealsIcon from '../Icons/MealsIcons';
import MotorizedSupportIcon from '../Icons/MotorizedSupportIcon';
import MoviesIcon from '../Icons/MoviesIcon';
import Mp3Icon from '../Icons/Mp3Icon';
import NewspaperIcon from '../Icons/NewspaperIcon';
import NoAmenitiesIcon from '../Icons/NoAmenitiesIcon';
import OffersIcon from '../Icons/OffersIcon';
import PersonaltvIcon from '../Icons/PersonaltvIcon';

import PillowsIcon from '../Icons/PillowsIcon';
import ReadinglightIcon from '../Icons/ReadinglightIcon';
import RecliningseatIcon from '../Icons/RecliningseatIcon';
import RescheduleIcon from '../Icons/RescheduleIcon';
import SatelliteIcon from '../Icons/SatelliteIcon';
import SearchIcon from '../Icons/SearchIcon';
import SeatBeltIcon from '../Icons/SeatBeltIcon';
import SeatIcon from '../Icons/SeatIcon';
import SleeperIcon from '../Icons/SleeperIcon';
import SeatCoverIcon from '../Icons/SeatCover';

import SnacksIcon from '../Icons/SnacksIcon';
import SoftdrinksIcon from '../Icons/SoftdrinksIcon';
import SwpIcon from '../Icons/SwpIcon';
import TimerIcon from '../Icons/TimerIcon';
import ToiletIcon from '../Icons/ToiletIcon';
import TopRatedIcon from '../Icons/TopRatedIcon';
import TourGuideIcon from '../Icons/TourGuideIcon';
import WaterbottleIcon from '../Icons/WaterbottleIcon';
import WetTissueIcon from '../Icons/WetTissueIcon';
import CctvIcon from '../Icons/CctvIcon';
import SmokingRoomIcon from '../Icons/SmokingRoom';
import WifiIcon from '../Icons/Amenities/WifiIcon';
import OntimeGuaranteeIcon from '../Icons/OnTimeGuarentee';

import BusSeatBookedIcon from '../Icons/BusSeatBookedIcon';
import BusSeatIcon from '../Icons/BusSeatIcon';
import BusSeatLadiesIcon from '../Icons/BusSeatLadiesIcon';
import BusSeatMenIcon from '../Icons/BusSeatMenIcon';
import BusSeatGreenIcon from '../Icons/BusSeatGreenIcon';
import BusSeatBlockedIcon from '../Icons/BusSeatBlockedIcon';
import BusSleeperAvailableIcon from '../Icons/BusSleeperAvailableIcon';
import BusSleeperBookedIcon from '../Icons/BusSleeperBookedIcon';
import BusSleeperIcon from '../Icons/BusSleeperIcon';
import BusSleeperLadiesIcon from '../Icons/BusSleeperLadiesIcon';
import BusSleeperMenIcon from '../Icons/BusSleeperMenIcon';
import BusSleeperBlockedIcon from '../Icons/BusSleeperBlockedIcon';
import SeatUnavailableIcon from '../Icons/SeatUnavailableIcon';

import BusSeatLadiesBlockedIcon from '../Icons/BusSeaterLadiesBlockedIcon';
import BusSeatMenBlockedIcon from '../Icons/BusSeaterMenBlockedIcon';
import BusSleeperMenBlockedIcon from '../Icons/BusSleeperMenBlockedIcon';
import BusSleeperLadiesBlockedIcon from '../Icons/BusSleeperLadiesBlockedIcon';

import BellIcon from '../Icons/BellIcon';
import CloseIcon from '../Icons/CloseIcon';
import BusLoaderIcon from '../Icons/BusLoader';

import DeepCleanIcon from '../Icons/DeepCleanIcon';
import FacemaskIcon from '../Icons/FacemaskIcon';
import NoBlanketIcon from '../Icons/NoBlanketIcon';
import SanitiserIcon from '../Icons/SanitiserIcon';
import ThermometerIcon from '../Icons/ThermometerIcon';
import SocialDistanceIcon from '../Icons/SocialDistancingIcon';

import FreeCancellationIcon from '../Icons/FreeCancellation';
import UserIcon from '../Icons/UserIcon';
import SeatBlockedViewIcon from '../Icons/SeatBlockedViewIcon';
import WindowSeatIcon from '../Icons/WindowSeatIcon';
import GoSafeIcon from '../Icons/GoSafeIcon';
import SteeringWheelIcon from '../Icons/SteeringWheel';
import GiftIcon from '../Icons/GiftIcon';
import DoubleTickIcon from '../Icons/DoubleTickIcon';
import NoBusIcon from '../Icons/NoBusIcon';
import WhiteTickIcon from '../Icons/WhiteTickIcon';

type IconProps = {
  name: string;
  styleProps?: {
    [k: string]: string; // better typescript – 🐨 css properties
  };
};

const Icon = ({name = '', styleProps}: IconProps) => {
  if (!name) return null;
  switch (name) {
    case 'AcIcon':
      return <AcIcon {...styleProps} />;
    case 'AcOnIcon':
      return <AcOnIcon {...styleProps} />;
    case 'ArrowDownIcon':
      return <ArrowDownIcon {...styleProps} />;
    case 'ArrowRight':
      return <ArrowRight {...styleProps} />;
    case 'ArrowLeft':
      return <ArrowLeft {...styleProps} />;
    case 'ArrowUpIcon':
      return <ArrowUpIcon {...styleProps} />;
    case 'DropArrowIcon':
      return <DropArrowIcon {...styleProps} />;
    case 'EticketIcon':
      return <EticketIcon {...styleProps} />;
    case 'OffersIcon':
      return <OffersIcon {...styleProps} />;
    case 'RescheduleIcon':
      return <RescheduleIcon {...styleProps} />;
    case 'SearchIcon':
      return <SearchIcon {...styleProps} />;
    case 'SwpIcon':
      return <SwpIcon {...styleProps} />;
    case 'TopRatedIcon':
      return <TopRatedIcon {...styleProps} />;

    case 'AirConditioner':
      return <AirConditionerIcon {...styleProps} />;
    case 'Bathroom':
      return <BathroomIcon {...styleProps} />;
    case 'Blankets':
      return <BlanketIcon {...styleProps} />;
    case 'BusHostess':
      return <BushostnessIcon {...styleProps} />;
    case 'CallCenterSupport':
      return <CallSupportIcon {...styleProps} />;
    case 'CentralTV':
      return <CentralTvIcon {...styleProps} />;
    case 'ChargingPoint':
      return <ChargingpointIcon {...styleProps} />;
    case 'CupHolder':
      return <CupholderIcon {...styleProps} />;
    case 'DefaultAmenitiesIcon':
      return <DefaultAmenitiesICon {...styleProps} />;
    case 'EmergencyContactNumber':
      return <EmergencyContactIcon {...styleProps} />;
    case 'EmergencyExit':
      return <EmergencyExitIcon {...styleProps} />;
    case 'FacialTissues':
      return <FacialTissueIcon {...styleProps} />;
    case 'FireExtinguisher':
      return <FireExtinguisherIcon {...styleProps} />;
    case 'Food':
      return <FoodIcon {...styleProps} />;
    case 'AirFreshner':
      return <FreshnerIcon {...styleProps} />;
    case 'Hammer':
      return <HammerIcon {...styleProps} />;
    case 'Headsets':
      return <HeadsetIcon {...styleProps} />;
    case 'Heater':
      return <HeaterIcon {...styleProps} />;
    case 'LiveBus':
      return <LiveBusIcon {...styleProps} />;
    case 'TrackMyBus':
      return <LiveBusTracking {...styleProps} />;
    case 'TimerIcon':
      return <TimerIcon {...styleProps} />;
    case 'MassageChair':
      return <MassageChairIcon {...styleProps} />;
    case 'Meal':
      return <MealsIcon {...styleProps} />;
    case 'MotorizedCalfsupport':
      return <MotorizedSupportIcon {...styleProps} />;
    case 'Movie':
      return <MoviesIcon {...styleProps} />;
    case 'MusicMp3':
      return <Mp3Icon {...styleProps} />;
    case 'Newspaper':
      return <NewspaperIcon {...styleProps} />;
    case 'NoAmenities':
      return <NoAmenitiesIcon {...styleProps} />;
    case 'PersonalTv':
      return <PersonaltvIcon {...styleProps} />;
    case 'Pillow':
      return <PillowsIcon {...styleProps} />;
    case 'ReadingLight':
      return <ReadinglightIcon {...styleProps} />;
    case 'RecliningSeat':
      return <RecliningseatIcon {...styleProps} />;
    case 'Satellite':
      return <SatelliteIcon {...styleProps} />;
    case 'SafetyBelt':
      return <SeatBeltIcon {...styleProps} />;
    case 'SeatIcon':
      return <SeatIcon {...styleProps} />;
    case 'SleeperIcon':
      return <SleeperIcon {...styleProps} />;
    case 'Snacks':
      return <SnacksIcon {...styleProps} />;
    case 'SoftDrink':
      return <SoftdrinksIcon {...styleProps} />;
    case 'Toilet':
      return <ToiletIcon {...styleProps} />;
    case 'TourGuide':
      return <TourGuideIcon {...styleProps} />;
    case 'WaterBottle':
      return <WaterbottleIcon {...styleProps} />;
    case 'WetNapkin':
      return <WetTissueIcon {...styleProps} />;
    case 'OnTimeGuarantee':
      return <OntimeGuaranteeIcon {...styleProps} />;
    case 'DisposableSeatCovers':
      return <SeatCoverIcon {...styleProps} />;
    case 'CCTV':
      return <CctvIcon {...styleProps} />;
    case 'SmokingRoom':
      return <SmokingRoomIcon {...styleProps} />;
    case 'Wifi':
      return <WifiIcon {...styleProps} />;

    case 'BusSeatIcon':
      return <BusSeatIcon {...styleProps} />;
    case 'BusSeatBookedIcon':
      return <BusSeatBookedIcon {...styleProps} />;
    case 'BusSeatLadiesIcon':
      return <BusSeatLadiesIcon {...styleProps} />;
    case 'BusSeatMenIcon':
      return <BusSeatMenIcon {...styleProps} />;
    case 'BusSeatGreenIcon':
      return <BusSeatGreenIcon {...styleProps} />;
    case 'BusSeatBlockedIcon':
      return <BusSeatBlockedIcon {...styleProps} />;
    case 'BusSleeperSelectedIcon':
      return <BusSleeperAvailableIcon {...styleProps} />;
    case 'BusSleeperBookedIcon':
      return <BusSleeperBookedIcon {...styleProps} />;
    case 'BusSleeperIcon':
      return <BusSleeperIcon {...styleProps} />;
    case 'BusSleeperLadiesIcon':
      return <BusSleeperLadiesIcon {...styleProps} />;
    case 'BusSleeperMenIcon':
      return <BusSleeperMenIcon {...styleProps} />;
    case 'BusSleeperBlockedIcon':
      return <BusSleeperBlockedIcon {...styleProps} />;
    case 'BusSeatLadiesBlockedIcon':
      return <BusSeatLadiesBlockedIcon {...styleProps} />;
    case 'BusSeatMenBlockedIcon':
      return <BusSeatMenBlockedIcon {...styleProps} />;
    case 'BusSleeperMenBlockedIcon':
      return <BusSleeperMenBlockedIcon {...styleProps} />;
    case 'BusSleeperLadiesBlockedIcon':
      return <BusSleeperLadiesBlockedIcon {...styleProps} />;

    case 'BusLoaderIcon':
      return <BusLoaderIcon {...styleProps} />;
    case 'SeatUnavailableIcon':
      return <SeatUnavailableIcon {...styleProps} />;
    case 'BellIcon':
      return <BellIcon {...styleProps} />;
    case 'CloseIcon':
      return <CloseIcon {...styleProps} />;
    case 'emergency-contact':
      return <EmergencyContactIcon {...styleProps} />;
    case 'thermameter':
      return <ThermometerIcon {...styleProps} />;
    case 'hand-sanitiser':
      return <SanitiserIcon {...styleProps} />;
    case 'facemask':
      return <FacemaskIcon {...styleProps} />;
    case 'noblanket':
      return <NoBlanketIcon {...styleProps} />;
    case 'deep-clean':
      return <DeepCleanIcon {...styleProps} />;
    case 'SocialDistanceIcon':
      return <SocialDistanceIcon {...styleProps} />;
      case 'icon-social-distance':
        return <SocialDistanceIcon {...styleProps} />;
     
    case 'BusIcon':
      return <BusIcon {...styleProps} />;

    case 'FreeCancellationIcon':
      return <FreeCancellationIcon {...styleProps} />;
    case 'UserIcon':
      return <UserIcon {...styleProps} />;
    case 'SeatBlockedViewIcon':
      return <SeatBlockedViewIcon {...styleProps} />;
    case 'WindowSeatIcon':
      return <WindowSeatIcon {...styleProps} />;
    case 'GoSafeIcon':
      return <GoSafeIcon {...styleProps} />;
    case 'SteeringWheelIcon':
      return <SteeringWheelIcon {...styleProps} />;
    case 'GiftIcon':
      return <GiftIcon {...styleProps} />;
    case 'DoubleTickIcon':
      return <DoubleTickIcon {...styleProps} />;
    case 'NoBusIcon':
      return <NoBusIcon {...styleProps}/>
    case 'WhiteTickIcon':
      return <WhiteTickIcon {...styleProps}/>
    default:
      return null;
  }
};

export default Icon;
